import { useAppTranslation } from '@flowus/common/i18n';
import './style.css';

import type { ComponentProps } from 'react';
import type { ReadonlyProp } from 'src/redux/types';

import { BlockEmptyView } from '../block-empty-view';

interface EmptyImageProps extends ReadonlyProp, Pick<ComponentProps<'div'>, 'onClick'> {
  defaultOpenPanel: boolean;
}
export function EmptyImage(props: EmptyImageProps) {
  const { t } = useAppTranslation();
  return (
    <BlockEmptyView
      defaultOpenPanel={props.defaultOpenPanel}
      readonly={props.readonly}
      iconProp={{
        name: 'IcUploadImage',
        size: 'normal',
      }}
      text={t('editor.component.image.add_image')}
      onClick={props.onClick}
      className={props.readonly ? 'cursor-default' : 'cursor-pointer'}
    />
  );
}
